window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.swiperJs, {
        defer: true,
        onload: () => window.cpap.createAndDispatchGlobalEvent('swiperReady'),
      });

      const playVideo = () => {
        const activeSlideContainerNode = document.querySelector(
          '.video-guide-slider .swiper-slide-active .slide-container'
        );

        const videoId = activeSlideContainerNode.dataset.videoId;
        const videoUrl = activeSlideContainerNode.dataset.videoUrl;

        if (videoUrl) {
          const activeSlideVideoNode = activeSlideContainerNode.querySelector(
            '.video-with-overlay video'
          );
          activeSlideVideoNode.querySelector('source')?.setAttribute('src', videoUrl);

          if (activeSlideContainerNode.dataset.autoplay == 'autoplay') {
            activeSlideVideoNode.pause();
            activeSlideVideoNode.load();
            activeSlideVideoNode.play();
          }
        } else if (videoId) {
          const iframeSrc =
            'https://www.youtube.com/embed/' +
            videoId +
            '?autoplay=1&mute=1&controls=0&disablekb=1&playlist=' +
            videoId +
            '&loop=1&modestbranding=1&start=0&showinfo=0&rel=0';

          activeSlideVideoNode.querySelector(
            '.video-with-overlay'
          ).innerHTML = `<iframe class="video-guide-iframe" src="${iframeSrc}">`;
        }
      };

      const setupVideoGuideSwiper = () => {
        function clearVideoGuideSlideClasses(swiper) {
          // Clear all custom classes
          swiper.slides.forEach((slide) => {
            slide.classList.remove('lt2', 'lt1', 'gt1', 'gt2');
          });
        }

        function updateVideoGuideSlideClasses(swiper) {
          const { activeIndex } = swiper;
          const slides = swiper.slides;

          // Add custom classes based on index
          if (slides[activeIndex - 2]) slides[activeIndex - 2].classList.add('lt2');
          if (slides[activeIndex - 1]) slides[activeIndex - 1].classList.add('lt1');
          if (slides[activeIndex + 1]) slides[activeIndex + 1].classList.add('gt1');
          if (slides[activeIndex + 2]) slides[activeIndex + 2].classList.add('gt2');

          // Clone processing for loop edges
          if (activeIndex === slides.length - 1) {
            if (slides[0]) slides[0].classList.add('gt1');
            if (slides[1]) slides[1].classList.add('gt2');
          }
          if (activeIndex === 0) {
            if (slides[slides.length - 1]) slides[slides.length - 1].classList.add('lt1');
            if (slides[slides.length - 2]) slides[slides.length - 2].classList.add('lt2');
          }
        }

        new window.Swiper('.video-guide-slider', {
          slidesPerView: 3,
          centeredSlides: true,
          speed: 700,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.video-guide-slider .swiper-button-next',
            prevEl: '.video-guide-slider .swiper-button-prev',
          },
          on: {
            init: function () {
              updateVideoGuideSlideClasses(this);

              let videoAppendTimeout;

              clearTimeout(videoAppendTimeout);

              videoAppendTimeout = setTimeout(() => {
                playVideo();
              }, window.appConfig.HOVER_DELAY_DURATION_50);
            },
            slideChangeTransitionStart: function () {
              clearVideoGuideSlideClasses(this);
              updateVideoGuideSlideClasses(this);
            },
            slideChangeTransitionEnd: function () {
              let videoAppendTimeout;

              clearTimeout(videoAppendTimeout);

              videoAppendTimeout = setTimeout(() => {
                playVideo();
              }, window.appConfig.HOVER_DELAY_DURATION_50);
            },
          },
        });
      };

      setTimeout(() => window.cpap.waitForVariableAndDomReady('Swiper', setupVideoGuideSwiper));

      const sliderNode = document.querySelector('.video-guide-slider');

      if (sliderNode.querySelector('.cpap__guide-carousel__slide-container--video')) {
        window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.bootstrapModalJs);

        const setGuideVideoModalHtml = (videoId, videoUrl) => {
          const videoModalNode = document.querySelector(
            '.cpap__cpap-guide-video-modal .cpap__cpap-guide-video-modal__video-container'
          );

          if (videoUrl) {
            const videoNode = document.createElement('video');
            videoNode.id = 'video';
            videoNode.src = videoUrl;
            videoNode.type = 'video/mp4';
            videoNode.controls = true;

            videoModalNode.innerHTML = '';
            videoModalNode.append(videoNode);
          } else if (videoId) {
            const iframeSrc =
              'https://www.youtube.com/embed/' + videoId + '?rel=0&playlist=' + videoId;
            videoModalNode.innerHTML = `<iframe class="cpap__cpap-guide-video-modal__iframe-video" src="${iframeSrc}" frameborder="0" allowfullscreen>`;
          }
        };

        let guideCarouselVideoModal;

        sliderNode.addEventListener('click', (event) => {
          const target = event.target.closest(
            '.swiper-slide-active .cpap__guide-carousel__slide-container--video'
          );

          if (target) {
            document
              .querySelector('.video-guide-slider .video-with-overlay .video-guide-iframe')
              ?.remove();

            const videoId = target.dataset.videoId;
            const videoUrl = target.dataset.videoUrl;

            if (videoId || videoUrl) {
              setGuideVideoModalHtml(videoId, videoUrl);

              if (!guideCarouselVideoModal) {
                guideCarouselVideoModal = new bootstrap.Modal(
                  document.querySelector('.cpap__cpap-guide-video-modal')
                );
              }

              guideCarouselVideoModal.show();
            }
          }
        });

        document
          .querySelector('.cpap__cpap-guide-video-modal__close-button')
          ?.addEventListener('click', () => {
            guideCarouselVideoModal?.hide();
          });

        document.addEventListener('hidden.bs.modal', () => {
          playVideo();

          document
            .querySelector(
              '.cpap__cpap-guide-video-modal .cpap__cpap-guide-video-modal__video-container'
            )
            .replaceChildren();
        });
      }
    },
    { priority: 'user-blocking' }
  );
});
